import Curriculum from '../components/curriculum/Curriculum'; 


export default function CurriculumView(){
    
    return (
        <><Curriculum /></>
    )
}